// src/components/admin/OrderForm.js
import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';

const OrderForm = ({ initialData, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    customerId: '',
    totalQuantity: '',
    totalAmount: '',
    orderedDate: '',
    deliveryDate: '',
    currentStatus: '',
  });

  // Populate form when editing
  useEffect(() => {
    if (initialData) {
      setFormData({
        customerId: initialData.customerId || '',
        totalQuantity: initialData.totalQuantity || '',
        totalAmount: initialData.totalAmount || '',
        orderedDate: initialData.orderedDate || '',
        deliveryDate: initialData.deliveryDate || '',
        currentStatus: initialData.currentStatus || '',
      });
    } else {
      resetForm();
    }
  }, [initialData]);

  const resetForm = () => {
    setFormData({
      customerId: '',
      totalQuantity: '',
      totalAmount: '',
      orderedDate: '',
      deliveryDate: '',
      currentStatus: '',
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validate required fields
    for (const [key, value] of Object.entries(formData)) {
      if (!value) {
        return;
      }
    }
    onSave(formData);
  };

  const handleClear = () => {
    if (initialData) {
      // If editing, reset to original data
      setFormData({
        customerId: initialData.customerId || '',
        totalQuantity: initialData.totalQuantity || '',
        totalAmount: initialData.totalAmount || '',
        orderedDate: initialData.orderedDate || '',
        deliveryDate: initialData.deliveryDate || '',
        currentStatus: initialData.currentStatus || '',
      });
    } else {
      resetForm();
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
  <Row className="mb-3">
    <Col md={4}>
      <Form.Group controlId="customerId">
        <Form.Label>Customer ID</Form.Label>
        <Form.Control
          type="number"
          name="customerId"
          value={formData.customerId}
          onChange={handleChange}
          placeholder="Enter Customer ID"
          required
        />
      </Form.Group>
    </Col>

    <Col md={4}>
      <Form.Group controlId="totalQuantity">
        <Form.Label>Total Quantity</Form.Label>
        <Form.Control
          type="number"
          name="totalQuantity"
          value={formData.totalQuantity}
          onChange={handleChange}
          placeholder="Enter total quantity"
          required
        />
      </Form.Group>
    </Col>

    <Col md={4}>
      <Form.Group controlId="totalAmount">
        <Form.Label>Total Amount</Form.Label>
        <Form.Control
          type="number"
          name="totalAmount"
          value={formData.totalAmount}
          onChange={handleChange}
          placeholder="Enter total amount"
          required
        />
      </Form.Group>
    </Col>
  </Row>

  <Row className="mb-3">
    <Col md={4}>
      <Form.Group controlId="orderedDate">
        <Form.Label>Ordered Date</Form.Label>
        <Form.Control
          type="date"
          name="orderedDate"
          value={formData.orderedDate}
          onChange={handleChange}
          placeholder="Select ordered date"
          required
        />
      </Form.Group>
    </Col>

    <Col md={4}>
      <Form.Group controlId="deliveryDate">
        <Form.Label>Delivery Date</Form.Label>
        <Form.Control
          type="date"
          name="deliveryDate"
          value={formData.deliveryDate}
          onChange={handleChange}
          placeholder="Select delivery date"
          required
        />
      </Form.Group>
    </Col>

    <Col md={4}>
      <Form.Group controlId="currentStatus">
        <Form.Label>Current Status</Form.Label>
        <Form.Control
          type="text"
          name="currentStatus"
          value={formData.currentStatus}
          onChange={handleChange}
          placeholder="e.g., Pending, Shipped, Delivered"
          required
        />
      </Form.Group>
    </Col>
  </Row>

  {/* Buttons */}
  <div className="d-flex gap-2">
    <Button type="submit" variant="primary">
      {initialData ? "Update" : "Create"}
    </Button>
    <Button type="button" variant="secondary" onClick={handleClear}>
      Clear
    </Button>
    <Button type="button" variant="outline-secondary" onClick={onCancel}>
      Cancel
    </Button>
  </div>
</Form>

  );
};

export default OrderForm;